export const pillsTypes = {
  ADJUSTMENTS: 'ADJUSTMENTS',
  BOOK_TO_TAX_DIFFERENCES: 'BOOK_TO_TAX_DIFFERENCES',
};

export const pillsDefinition = [
  { label: 'Adjustments', type: pillsTypes.ADJUSTMENTS },
  { label: 'Book to Tax Differences', type: pillsTypes.BOOK_TO_TAX_DIFFERENCES },
];
